var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-user-mono"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6653 4.98298C12.6653 5.46509 12.5704 5.9425 12.3859 6.38793C12.2015 6.83337 11.9311 7.23811 11.5902 7.57905C11.2494 7.92 10.8447 8.19046 10.3993 8.375C9.95388 8.55955 9.4765 8.65455 8.99438 8.6546C8.02071 8.6547 7.08687 8.26801 6.39831 7.57958C5.70974 6.89116 5.32286 5.9574 5.32276 4.98373C5.32271 4.50161 5.41762 4.02421 5.60207 3.57877C5.78652 3.13334 6.0569 2.72859 6.39778 2.38765C7.0862 1.69909 8.01996 1.3122 8.99363 1.3121C9.96731 1.312 10.9011 1.6987 11.5897 2.38712C12.2783 3.07554 12.6652 4.0093 12.6653 4.98298ZM8.99401 9.77773C3.70726 9.77773 1.65076 13.1422 1.65076 14.7075C1.65076 16.272 6.02851 16.689 8.99401 16.689C11.9595 16.689 16.3373 16.272 16.3373 14.7075C16.3373 13.1422 14.2808 9.77773 8.99401 9.77773Z",
    fill: "#989BA2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuProfile);
export default __webpack_public_path__ + "static/media/icon_menu_profile.cce2e8c309ebae01d30428fb3b3402ac.svg";
export { ForwardRef as ReactComponent };